const drawerState = {
  preserveOpenState: true,
  typeDrawers: {},
  labelItems: {},
  nestedDrawers: {},
};

function getOpen(collection, key) {
  if (!drawerState.preserveOpenState || !key) return false;
  return collection[key] === true;
}

function setOpen(collection, key, open) {
  if (!drawerState.preserveOpenState || !key) return;
  collection[key] = open === true;
}

function clearOpenState() {
  drawerState.typeDrawers = {};
  drawerState.labelItems = {};
  drawerState.nestedDrawers = {};
}

export function getDrawerStatePreserved() {
  return drawerState.preserveOpenState;
}

export function setDrawerStatePreserved(preserved) {
  drawerState.preserveOpenState = preserved === true;
  if (!drawerState.preserveOpenState) {
    clearOpenState();
  }
}

export function getTypeDrawerOpen(key) {
  return getOpen(drawerState.typeDrawers, key);
}

export function setTypeDrawerOpen(key, open) {
  setOpen(drawerState.typeDrawers, key, open);
}

export function getLabelDrawerOpen(key) {
  return getOpen(drawerState.labelItems, key);
}

export function setLabelDrawerOpen(key, open) {
  setOpen(drawerState.labelItems, key, open);
}

export function getNestedDrawerOpen(key) {
  return getOpen(drawerState.nestedDrawers, key);
}

export function setNestedDrawerOpen(key, open) {
  setOpen(drawerState.nestedDrawers, key, open);
}

export function getLabelDrawerKey(label) {
  if (!label) return null;
  const labelType = label.type || 'LABEL';
  const parentKey = label.parentImageId ? `:${label.parentImageId}` : '';
  return `${labelType}${parentKey}:${label.id}`;
}
